module.exports = __webpack_public_path__ + "img/tour-59.83f97ef6.png";